import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TRoleTypePositionType {
  id: number;
  roleTypeCode: string;
  positionTypeId: number;
}

export interface IRoleTypePositionType extends TRoleTypePositionType {}

const RoleTypePositionType = Model(
  (model: TRoleTypePositionType): IRoleTypePositionType => {
    const _roleTypePositionType: TRoleTypePositionType = Object.assign(
      {},
      model
    );

    let create = (
      RoleTypePositionType: IRoleTypePositionType
    ): IRoleTypePositionType => {
      let obj = ValidatableObject(RoleTypePositionType);
      return obj;
    };
    let roleTypePositionType = {
      get id() {
        return _roleTypePositionType.id;
      },
      set id(value) {
        _roleTypePositionType.id = value;
      },
      get roleTypeCode() {
        return _roleTypePositionType.roleTypeCode;
      },
      set roleTypeCode(value) {
        _roleTypePositionType.roleTypeCode = value;
      },
      get positionTypeId() {
        return _roleTypePositionType.positionTypeId;
      },
      set positionTypeId(value) {
        _roleTypePositionType.positionTypeId = value;
      }
    };
    return create(roleTypePositionType);
  }
);

export default RoleTypePositionType;
